import GuildAdd from "@/views/guild/GuildAdd";
import GuildList from "@/views/guild/GuildList";
import GuildEdit from "@/views/guild/GuildEdit";


const routes = [
 {
    path: '/Guild/Add',
    name: 'GuildAdd',
    component: GuildAdd,
    meta:{requiredAuth:true}
  },
 {
    path: '/Guild/List',
    name: 'GuildList',
    component: GuildList,
    meta:{requiredAuth:true}
  },
 {
    path: '/Guild/Edit/:id',
    name: 'GuildEdit',
    component: GuildEdit,
    meta:{requiredAuth:true}
  },
]

export default routes